import { ControlledSystemMultiTab } from '@cms/components/data/MultiTab';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { MdOutlineExpand } from 'react-icons/md';
import PageContainer from '../../components/ui/PageContainer';

interface IQuestion {
    id: number;

    content: string;
    answer: string;
}

const HelpPage = () => {
    const data: Array<{
        id: number;
        title: string;
        items: IQuestion[];
    }> = [
            {
                id: 1,
                title: 'General',
                items: [
                    {
                        id: 1,
                        content: "What is this application about?",
                        answer: "This application is designed to help users manage their content efficiently."
                    },
                    {
                        id: 2,
                        content: "How do I navigate through the app?",
                        answer: "You can use the top menu to access different sections of the app."
                    }
                ]
            },
            {
                id: 2,
                title: 'Composer',
                items: [
                    {
                        id: 1,
                        content: "How do I create a new story?",
                        answer: "To create a new story, go to the 'Stories' page and click on 'Create'. Fill in the required fields and submit."
                    },
                    {
                        id: 2,
                        content: "How can I edit an existing story?",
                        answer: "You can edit an existing story by navigating to the 'Stories' page, selecting the story you want to edit, and clicking on 'Edit'."
                    }
                ]
            }
        ];

    return (
        <PageContainer>
            <div className='w-full flex flex-col items-start p-2'>
                <ControlledSystemMultiTab
                    tabs={data.map((item) => ({
                        label: item.title,
                        content: (
                            <div>
                                {item.items.map((q) => {
                                    const identifier = `accordion-${item.id}-${q.id}`;

                                    return (
                                        <Accordion
                                            key={identifier}
                                        >
                                            <AccordionSummary
                                                expandIcon={<MdOutlineExpand />}
                                                aria-controls={`panel-content-${identifier}`}
                                                id={`panel-header-${identifier}`}
                                            >
                                                <p>{q.content}</p>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {q.answer}
                                            </AccordionDetails>
                                        </Accordion>
                                    )
                                })}
                            </div>
                        )
                    }))}
                />
            </div>
        </PageContainer>
    )
}

export default HelpPage